import { RouteObject } from 'react-router-dom'
import { default as Invoices } from '.'
import { PageLayout } from '$components/common'

const basePath = '/stock/invoices'
export const invoicesRoutes: RouteObject[] = [
  {
    path: `${basePath}`,
    element: (
      <PageLayout title="Incoming Invoices" displayLeftTitle={false}>
        <Invoices.Invoices.Component />
      </PageLayout>
    ),
    // On the Incoming Invoices page we only want to display any invoices that
    // are currently unreceived, no received invoices should be shown.
    loader: Invoices.Invoices.LoaderFactory({ onlyNonReceived: true }),
  },
  {
    path: `${basePath}/history`,
    element: (
      <PageLayout title="Invoice History" displayLeftTitle={false}>
        <Invoices.InvoiceHistory.Component />
      </PageLayout>
    ),
    // On the Invoice History page we need invoices in all states,
    // including received ones, so don't trigger any filtering on status on the loader
    loader: Invoices.InvoiceHistory.Loader,
  },
  {
    path: `${basePath}/add`,
    element: (
      <PageLayout title="Receive Purchase Order" htmlTitleOnly>
        <Invoices.EditInvoice.Component />
      </PageLayout>
    ),
    loader: Invoices.EditInvoice.Loader,
  },
  {
    path: `${basePath}/:invoiceId`,
    element: (
      <PageLayout title="Receive Invoice" htmlTitleOnly>
        <Invoices.EditInvoice.Component />
      </PageLayout>
    ),
    loader: Invoices.EditInvoice.Loader,
  },
]
